<template>
<div class="chapter">
<div class="inner_page">
<a id="page_viii">
<h2 class="fm_title">Glossary</h2>
<table>
<tbody><tr>
<td class="tab"><span href="#/xhtml/13_Chapter_6#gloss_1" id="gloss-1" title="Link target outside of Sample"><em class="italic">agoge</em></span></td>
<td class="tab">the Spartan system of raising and educating children.</td>
</tr>
<tr>
<td class="tab"><span href="#/xhtml/14_Chapter_7#gloss_2" id="gloss-2" title="Link target outside of Sample"><em class="italic">Gerousia</em></span></td>
<td class="tab">the council of Elders, roughly analogous with a senate.</td>
</tr>
<tr>
<td class="tab"><span href="#/xhtml/14_Chapter_7#gloss_3" id="gloss-3" title="Link target outside of Sample"><em class="italic">harmost</em></span></td>
<td class="tab">a military governor of a town or area.</td>
</tr>
<tr>
<td class="tab"><a href="#/xhtml/08_Chapter_1#gloss_4" id="gloss-4"><em class="italic">helots</em></a></td>
<td class="tab">those bound by the Spartans in a condition between serfdom and slavery.</td>
</tr>
<tr>
<td class="tab"><a href="#/xhtml/08_Chapter_1#gloss_5" id="gloss-5"><em class="italic">homoi</em></a></td>
<td class="tab">the ‘Equals’ – full Spartan citizens.</td>
</tr>
<tr>
<td class="tab"><span href="#/xhtml/13_Chapter_6#gloss_6" id="gloss-6" title="Link target outside of Sample"><em class="italic">kleros</em></span></td>
<td class="tab">land held by a Spartiate to pay for his upkeep.</td>
</tr>
<tr>
<td class="tab"><a href="#/xhtml/08_Chapter_1#gloss_7" id="gloss-7"><em class="italic">krypteia</em></a></td>
<td class="tab">Spartan spies and assassins.</td>
</tr>
<tr>
<td class="tab"><span href="#/xhtml/13_Chapter_6#gloss_8" id="gloss-8" title="Link target outside of Sample"><em class="italic">mothaces</em></span></td>
<td class="tab">non-Spartiates brought up under the <em class="italic">agoge</em> system.</td>
</tr>
<tr>
<td class="tab"><span href="#/xhtml/14_Chapter_7#gloss_9" id="gloss-9" title="Link target outside of Sample"><em class="italic">navarchos</em></span></td>
<td class="tab">naval commander.</td>
</tr>
<tr>
<td class="tab"><a href="#/xhtml/08_Chapter_1#gloss_10" id="gloss-10"><em class="italic">perioiki</em></a></td>
<td class="tab">non-Spartans living in Laconia and subject to Sparta although nominally independent.</td>
</tr>
<tr>
<td class="tab"><span href="#/xhtml/16_Chapter_9#gloss_11" id="gloss-11" title="Link target outside of Sample"><em class="italic">polemarch</em></span></td>
<td class="tab">army or phalanx commander.</td>
</tr>
<tr>
<td class="tab"><span href="#/xhtml/18_Chapter_11#gloss_12" id="gloss-12" title="Link target outside of Sample"><em class="italic">rhetra</em></span></td>
<td class="tab">a proposal put to the assembly of the Spartan people.</td>
</tr>
<tr>
<td class="tab"><span href="#/xhtml/18_Chapter_11#gloss_13" id="gloss-13" title="Link target outside of Sample"><em class="italic">sarissa</em></span></td>
<td class="tab">a long pike adopted by Philip II of Macedon.</td>
</tr>
<tr>
<td class="tab"><a href="#/xhtml/07_Introduction#gloss_14" id="gloss-14"><em class="italic">Spartiates</em></a></td>
<td class="tab">the top rank of Spartan society.</td>
</tr>
<tr>
<td class="tab"><span href="#/xhtml/19_Chapter_12#gloss_15" id="gloss-15" title="Link target outside of Sample"><em class="italic">stasis</em></span></td>
<td class="tab">civil strife up to and including civil war.</td>
</tr>
<tr>
<td class="tab"><span href="#/xhtml/10_Chapter_3#gloss_16" id="gloss-16" title="Link target outside of Sample"><em class="italic">strategos</em></span></td>
<td class="tab">a general.</td>
</tr>
<tr>
<td class="tab"><span href="#/xhtml/13_Chapter_6#gloss_17" id="gloss-17" title="Link target outside of Sample"><em class="italic">syssitia</em></span></td>
<td class="tab">the Spartan military mess. Non-payment of mess fees reduced a Spartiate from that rank.</td>
</tr>
<tr>
<td class="tab"><span href="#/xhtml/16_Chapter_9#gloss_18" id="gloss-18" title="Link target outside of Sample"><em class="italic">tresantes</em></span></td>
<td class="tab">‘Tremblers’ – survivors of a losing battle. Again, this title cost a Spartiate his rank.</td>
</tr>
</tbody></table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Glossary.vue?e1480ece